import {FC, memo, useContext, useEffect} from 'react';
import {useRecoilState, useRecoilStateLoadable, useRecoilValue, useResetRecoilState, useSetRecoilState} from 'recoil';

import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import {TableBodyContainer} from './TableBody/TableBodyContainer';
import {TablePagination, Typography} from '@mui/material';

import {EventBusContext} from '../../../providers/EventBus';
import {IPageableTable} from '../../../shared/types/pageable.types';
import {
  importOfDevicesPageable,
  importOfDevicesQueryTrigger,
  importOfDevicesState,
  openedImportRowsState,
} from '../../../store/service-request-imports/atoms';
import {useDebouncePageable} from '../../../hooks/useDebouncePageable';
import {importOfDevicesQuery} from '../../../store/service-request-imports/selectors';
import {TableHeadContainer} from './TableHeadContainer';

export const ImportDevicesTable: FC = memo(() => {
  const [{state: importsState, contents: importsContents}, setImports] = useRecoilStateLoadable(importOfDevicesQuery);
  const {totalElements, content} = useRecoilValue(importOfDevicesState);
  const resetImports = useResetRecoilState(importOfDevicesState);
  const [pageable, setPageable] = useRecoilState(importOfDevicesPageable);
  const {
    pageableToDebounce: {page, size},
    handleChangePage,
    handleChangeRowsPerPage,
  } = useDebouncePageable<IPageableTable>(pageable, setPageable);
  const setOpen = useSetRecoilState(openedImportRowsState);
  const triggerQuery = useSetRecoilState(importOfDevicesQueryTrigger);
  const {bus} = useContext(EventBusContext);

  useEffect(() => {
    importsState === 'hasValue' && setImports(importsContents);

    importsState === 'hasError' &&
      bus?.emit('error', [
        importsContents,
        {
          toastId: 'serviceRequestImports',
        },
      ]);

    return () => {
      importsState !== 'loading' && triggerQuery((v) => v + 1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importsState]);

  useEffect(() => {
    return () => {
      setOpen([]);
      resetImports();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHeadContainer state={importsState} />
          <TableBodyContainer rowsPerPage={size} page={page} serviceRequestImports={content} />
        </Table>
        <TablePagination
          rowsPerPageOptions={[20]}
          component="div"
          count={totalElements}
          page={page}
          rowsPerPage={size}
          onPageChange={handleChangePage}
          onRowsPerPageChange={(e) => {
            localStorage.setItem('importOfDevicesPerPage', e?.target.value as string);
            handleChangeRowsPerPage(e);
          }}
        />
      </TableContainer>
      {!totalElements && importsState === 'hasValue' && (
        <Typography component="div" sx={{textAlign: 'center'}}>
          Нет импортов
        </Typography>
      )}
    </>
  );
});
